import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-[70vh] items-center justify-center px-4 md:px-8 py-20">
      <div className="flex w-full max-w-xl flex-col items-center gap-5 text-center">
        <span className="font-heading text-6xl md:text-8xl font-semibold text-primary-500">
          404
        </span>
        <h1 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
          抱歉，页面不见了
        </h1>
        <p className="max-w-md text-sm md:text-base leading-relaxed text-foreground-600">
          你访问的页面可能已被移动或删除。你可以返回首页，或前往品牌介绍、相关资讯、资源查询继续浏览。
        </p>
        <div className="mt-2 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/resources"
            className="inline-flex items-center gap-2 rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 whitespace-nowrap"
          >
            资源查询
          </Link>
        </div>
      </div>
    </div>
  );
}